// ==============================================================================
// Story: Poetry Special - I am a Whale (ぼくはくじら)
// ==============================================================================

const STORY_DATA = [
  {
    title: "Part 1: Shapes in the Sky",
    rubyText: [
      { w: "I", r: "アイ" },
      { w: "am", r: "アム" },
      { w: "a", r: "ア" },
      { w: "whale.", r: "ホエール", s: true },
      { w: "\n" },
      { w: "I", r: "アイ" },
      { w: "am", r: "アム" },
      { w: "a", r: "ア" },
      { w: "horse.", r: "ホース" , s: true},
      { w: "\n" },
      { w: "I", r: "アイ" },
      { w: "am", r: "アム" },
      { w: "a", r: "ア" },
      { w: "sheep.", r: "シープ" , s: true},
      { w: "\n" },
      { w: "I", r: "アイ" },
      { w: "am", r: "アム" },
      { w: "a", r: "ア" },
      { w: "mackerel.", r: "マカレル" , s: true},
      { w: "\n" },
      { w: "I", r: "アイ" },
      { w: "can", r: "キャン" },
      { w: "even", r: "イーブン" },
      { w: "be", r: "ビー" },
      { w: "a", r: "ア" },
      { w: "dinosaur.", r: "ダイナソー" , s: true},
    ],
    en: "I am a whale.\nI am a horse.\nI am a sheep.\nI am a mackerel.\nI can even be a dinosaur.",
    ja: "ぼくは くじら。\nぼくは うま。\nぼくは ひつじ。\nぼくは さば。\nきょうりゅうにだって なれるんだ。",
    learning: {
      vocab: [
        { word: "whale", mean: "クジラ" },
        { word: "sheep", mean: "ヒツジ" },
        { word: "mackerel", mean: "サバ" },
        { word: "dinosaur", mean: "恐竜" },
      ],
      grammar: {
        title: "can be ...",
        desc: "「～になることができる（なりうる）」という可能性を表す表現です。",
        key: "I can even be a dinosaur.",
      },
    },
    color: "bg-sky-50",
    accent: "text-sky-600",
    mood: { rate: 0.9, pitch: 1.0 },
    image: "images/002/01.jpg",
    startTime: 0,
  },
  {
    title: "Part 2: Born and Gone",
    rubyText: [
      { w: "I", r: "アイ" },
      { w: "am", r: "アム" },
      { w: "born,", r: "ボーン", s: true },
      { w: "and", r: "アンド" },
      { w: "I", r: "アイ" },
      { w: "disappear.", r: "ディスアピア" , s: true},
      { w: "\n" },
      { w: "Even", r: "イーブン" },
      { w: "if", r: "イフ" },
      { w: "I", r: "アイ" },
      { w: "disappear,", r: "ディスアピア", s: true },
      { w: "I", r: "アイ" },
      { w: "appear", r: "アピア" },
      { w: "again", r: "アゲイン" },
      { w: "and", r: "アンド" },
      { w: "again.", r: "アゲイン" , s: true},
      { w: "\n" },
      { w: "I", r: "アイ" },
      { w: "change", r: "チェンジ" },
      { w: "my", r: "マイ" },
      { w: "shape,", r: "シェイプ", s: true },
      { w: "and", r: "アンド" },
      { w: "I", r: "アイ" },
      { w: "flow.", r: "フロー" , s: true},
    ],
    en: "I am born, and I disappear.\nEven if I disappear, I appear again and again.\nI change my shape, and I flow.",
    ja: "ぼくは うまれて きえていく。\nきえても なんどもあらわれて\nかたちをかえて ながれてく。",
    learning: {
      vocab: [
        { word: "born", mean: "生まれる" },
        { word: "disappear", mean: "消える" },
        { word: "appear", mean: "現れる" },
        { word: "flow", mean: "流れる" },
      ],
      grammar: {
        title: "Even if ...",
        desc: "「たとえ～だとしても」という仮定を表す接続詞です。",
        key: "Even if I disappear...",
      },
    },
    color: "bg-blue-50",
    accent: "text-blue-600",
    mood: { rate: 0.85, pitch: 0.95 },
    image: "images/002/02.jpg",
    startTime: 20,
  },
  {
    title: "Part 3: Anything",
    rubyText: [
      { w: "I", r: "アイ" },
      { w: "can", r: "キャン" },
      { w: "be", r: "ビー" },
      { w: "anything.", r: "エニシング" , s: true},
      { w: "\n" },
      { w: "I", r: "アイ" },
      { w: "am", r: "アム" },
      { w: "not", r: "ノット" },
      { w: "just", r: "ジャスト" },
      { w: "one", r: "ワン" },
      { w: "thing.", r: "シング" , s: true},
      { w: "\n" },
      { w: "Where", r: "ホエア" },
      { w: "shall", r: "シャル" },
      { w: "I", r: "アイ" },
      { w: "go", r: "ゴー" },
      { w: "next?", r: "ネクスト" , s: true},
      { w: "\n" },
      { w: "What", r: "ワット" },
      { w: "shall", r: "シャル" },
      { w: "I", r: "アイ" },
      { w: "become", r: "ビカム" },
      { w: "next?", r: "ネクスト" , s: true},
    ],
    en: "I can be anything.\nI am not just one thing.\nWhere shall I go next?\nWhat shall I become next?",
    ja: "ぼくは なんにでもなれるんだ。\nたったひとつのものじゃない。\nつぎはどこにいこうかな。\nつぎはなにになろうかな。",
    learning: {
      vocab: [
        { word: "anything", mean: "何でも" },
        { word: "become", mean: "～になる" },
        { word: "next", mean: "次は" },
      ],
      grammar: {
        title: "助動詞 shall",
        desc: "「～しましょうか？」「～しようかな？」と、未来の意志や提案を表すときに使います。",
        key: "Where shall I go next?",
      },
    },
    color: "bg-indigo-50",
    accent: "text-indigo-600",
    mood: { rate: 1.0, pitch: 1.1 },
    image: "images/002/03.jpg",
    startTime: 40,
  },
  {
    title: "Part 4: Tomorrow's Wind",
    rubyText: [
      { w: "Tomorrow,", r: "トゥモロー", s: true },
      { w: "tomorrow's", r: "トゥモローズ" },
      { w: "wind", r: "ウィンド" },
      { w: "will", r: "ウィル" },
      { w: "blow.", r: "ブロー" , s: true},
      { w: "\n" },
      { w: "It", r: "イット" },
      { w: "is", r: "イズ" },
      { w: "a", r: "ア" },
      { w: "different", r: "ディファレント" },
      { w: "wind", r: "ウィンド", s: true },
      { w: "from", r: "フロム" },
      { w: "today.", r: "トゥデイ" , s: true},
      { w: "\n" },
      { w: "So", r: "ソー", s: true },
      { w: "I", r: "アイ" },
      { w: "will", r: "ウィル" },
      { w: "be", r: "ビー" },
      { w: "different", r: "ディファレント", s: true },
      { w: "from", r: "フロム" },
      { w: "today.", r: "トゥデイ" , s: true},
      { w: "\n" },
      { w: "I", r: "アイ" },
      { w: "change", r: "チェンジ" },
      { w: "my", r: "マイ" },
      { w: "shape,", r: "シェイプ", s: true },
      { w: "and", r: "アンド" },
      { w: "I", r: "アイ" },
      { w: "flow.", r: "フロー" , s: true},
    ],
    en: "Tomorrow, tomorrow's wind will blow.\nIt is a different wind from today.\nSo I will be different from today.\nI change my shape, and I flow.",
    ja: "あしたはあしたのかぜがふく。\nきょうとはちがうかぜだから。\nきょうとはちがうぼくになり\nかたちをかえてながれてく。",
    learning: {
      vocab: [
        { word: "wind", mean: "風" },
        { word: "blow", mean: "吹く" },
        { word: "different", mean: "違う" },
      ],
      grammar: {
        title: "different from ...",
        desc: "「～とは違う」と比較するときの表現です。",
        key: "It is a different wind from today.",
      },
    },
    color: "bg-emerald-50",
    accent: "text-emerald-600",
    mood: { rate: 0.95, pitch: 1.0 },
    image: "images/002/04.jpg",
    startTime: 60,
  },
  {
    title: "Part 5: Just Me",
    rubyText: [
      { w: "No", r: "ノー" },
      { w: "matter", r: "マター" },
      { w: "how", r: "ハウ" },
      { w: "I", r: "アイ" },
      { w: "change,", r: "チェンジ", s: true },
      { w: "\n" },
      { w: "I", r: "アイ" },
      { w: "am", r: "アム" },
      { w: "just", r: "ジャスト" },
      { w: "me,", r: "ミー", s: true },
      { w: "as", r: "アズ" },
      { w: "I", r: "アイ" },
      { w: "am.", r: "アム" , s: true},
      { w: "\n" },
      { w: "I", r: "アイ" },
      { w: "flow", r: "フロー" },
      { w: "through", r: "スルー" },
      { w: "this", r: "ディス" },
      { w: "moment", r: "モーメント", s: true },
      { w: "now.", r: "ナウ" , s: true},
    ],
    en: "No matter how I change,\nI am just me, as I am.\nI flow through this moment now.",
    ja: "どれだけかたちをかえたって\nぼくはぼくであるがまま。\nいまこのときをながれてく。",
    learning: {
      vocab: [
        { word: "change", mean: "変わる" },
        { word: "moment", mean: "瞬間、とき" },
        { word: "through", mean: "～を通って" },
      ],
      grammar: {
        title: "as I am",
        desc: "「あるがままの私」「今の私」という意味の表現です。",
        key: "I am just me, as I am.",
      },
    },
    color: "bg-cyan-50",
    accent: "text-cyan-600",
    mood: { rate: 0.9, pitch: 0.9 },
    image: "images/002/05.jpg",
    startTime: 80,
  },
];

const QUIZ_POOL = [
  {
    q: "What does 'I' NOT become in Part 1?",
    options: ["A whale", "A dog", "A dinosaur"],
    a: 1,
    exp: "詩の中で犬(dog)にはなっていません。",
  },
  {
    q: "What fish appears in the poem?",
    options: ["Tuna", "Salmon", "Mackerel"],
    a: 2,
    exp: "「ぼくはさば」なので Mackerel です。",
  },
  {
    q: "What happens after 'I' disappear?",
    options: ["I sleep forever", "I appear again", "I become rain"],
    a: 1,
    exp: "Part 2で 'I appear again and again'（何度も現れる）と言っています。",
  },
  {
    q: "What will blow tomorrow?",
    options: ["Tomorrow's wind", "Yesterday's wind", "No wind"],
    a: 0,
    exp: "Part 4で 'Tomorrow's wind will blow'（明日は明日の風が吹く）と言っています。",
  },
  {
    q: "Is the wind tomorrow the same as today?",
    options: ["Yes", "No, it is different", "Maybe"],
    a: 1,
    exp: "Part 4で 'It is a different wind from today' と言っています。",
  },
  {
    q: "Does 'I' change?",
    options: ["No, never", "Yes, 'I' change shape", "Only color changes"],
    a: 1,
    exp: "Part 2や4で 'I change my shape' と言っています。",
  },
  {
    q: "What stays the same?",
    options: ["The shape", "The wind", "'I' am just me"],
    a: 2,
    exp: "Part 5で、形は変わっても 'I am just me'（ぼくはぼく）だと言っています。",
  },
  {
    q: "Which large sea animal is mentioned first?",
    options: ["A shark", "A dolphin", "A whale"],
    a: 2,
    exp: "冒頭で 'I am a whale' と言っています。",
  },
  {
    q: "Can the speaker become a dinosaur?",
    options: ["Yes", "No", "Only in dreams"],
    a: 0,
    exp: "Part 1で 'I can even be a dinosaur' と述べています。",
  },
  {
    q: "What action does the speaker do in Part 2?",
    options: ["Fly", "Swim", "Flow"],
    a: 2,
    exp: "Part 2の最後で 'I flow' と言っています。",
  },
  {
    q: "What does the speaker ask in Part 3?",
    options: ["What time is it?", "Where shall I go next?", "Who are you?"],
    a: 1,
    exp: "Part 3で 'Where shall I go next?' と問いかけています。",
  },
  {
    q: "Is the speaker just one thing?",
    options: ["Yes", "No, not just one thing", "We don't know"],
    a: 1,
    exp: "Part 3で 'I am not just one thing' と言っています。",
  },
  {
    q: "Why will the speaker be different tomorrow?",
    options: [
      "Because the wind is different",
      "Because it is raining",
      "Because they are tired",
    ],
    a: 0,
    exp: "Part 4で、風が違うから自分も違う(So I will be different)と言っています。",
  },
  {
    q: "What animal is mentioned in Part 1 besides a whale?",
    options: ["A cat", "A sheep", "A bird"],
    a: 1,
    exp: "Part 1で 'I am a sheep' と言っています。",
  },
  {
    q: "What time is mentioned in the final line?",
    options: ["Yesterday", "Tomorrow", "This moment now"],
    a: 2,
    exp: "最後の行は 'I flow through this moment now' です。",
  },
];

const SCRAMBLE_POOL = [
  {
    q: "恐竜にだってなれるんだ。",
    w: ["I", "can", "even", "be", "a", "dinosaur"],
    o: [0, 1, 2, 3, 4, 5],
  },
  {
    q: "ぼくは生まれて、消えていく。",
    w: ["I", "am", "born", "and", "I", "disappear"],
    o: [0, 1, 2, 3, 4, 5],
  },
  {
    q: "ぼくは何にでもなれる。",
    w: ["I", "can", "be", "anything"],
    o: [0, 1, 2, 3],
  },
  {
    q: "明日は明日の風が吹く。",
    w: ["Tomorrow", "tomorrow's", "wind", "will", "blow"],
    o: [0, 1, 2, 3, 4],
  },
  {
    q: "それは今日とは違う風だ。",
    w: ["It", "is", "a", "different", "wind", "from", "today"],
    o: [0, 1, 2, 3, 4, 5, 6],
  },
  {
    q: "ぼくはあるがままのぼくだ。",
    w: ["I", "am", "just", "me", "as", "I", "am"],
    o: [0, 1, 2, 3, 4, 5, 6],
  },
  {
    q: "ぼくはクジラだ。",
    w: ["I", "am", "a", "whale"],
    o: [0, 1, 2, 3],
  },
  {
    q: "ぼくはウマだ。",
    w: ["I", "am", "a", "horse"],
    o: [0, 1, 2, 3],
  },
  {
    q: "ぼくはヒツジだ。",
    w: ["I", "am", "a", "sheep"],
    o: [0, 1, 2, 3],
  },
  {
    q: "ぼくはサバだ。",
    w: ["I", "am", "a", "mackerel"],
    o: [0, 1, 2, 3],
  },
  {
    q: "たとえ僕が消えても。",
    w: ["Even", "if", "I", "disappear"],
    o: [0, 1, 2, 3],
  },
  {
    q: "ぼくは何度も現れる。",
    w: ["I", "appear", "again", "and", "again"],
    o: [0, 1, 2, 3, 4],
  },
  {
    q: "ぼくは形を変えて流れる。",
    w: ["I", "change", "my", "shape", "and", "I", "flow"],
    o: [0, 1, 2, 3, 4, 5, 6],
  },
  {
    q: "次はどこへ行こうか？",
    w: ["Where", "shall", "I", "go", "next"],
    o: [0, 1, 2, 3, 4],
  },
  {
    q: "次はなにになろうか？",
    w: ["What", "shall", "I", "become", "next"],
    o: [0, 1, 2, 3, 4],
  },
];

const FILL_IN_THE_BLANK_POOL = [
  {
    q: "I can _______ a dinosaur.",
    options: ["am", "be", "is", "are"],
    a: 1,
    exp: "can の後ろは動詞の原形 be になります。",
  },
  {
    q: "I appear _______ and again.",
    options: ["once", "again", "then", "now"],
    a: 1,
    exp: "again and again で「何度も」という意味です。",
  },
  {
    q: "Where _______ I go next?",
    options: ["shall", "am", "have", "does"],
    a: 0,
    exp: "「～しましょうか（しようかな）」という未来・意志を表す shall です。",
  },
  {
    q: "It is different _______ today.",
    options: ["to", "of", "from", "by"],
    a: 2,
    exp: "different from ～ で「～とは違う」という意味です。",
  },
  {
    q: "I flow _______ this moment.",
    options: ["on", "at", "through", "under"],
    a: 2,
    exp: "「～を通って」「～を抜けて」という意味の through が合います。",
  },
  {
    q: "I am _______ (born).",
    options: ["bear", "bore", "born", "birth"],
    a: 2,
    exp: "「生まれる」という受動的な意味で be born の形を使います。",
  },
  {
    q: "Even _______ (if) I disappear.",
    options: ["if", "so", "though", "when"],
    a: 0,
    exp: "Even if で「たとえ～だとしても」です。",
  },
  {
    q: "I _______ (change) my shape.",
    options: ["change", "changes", "changing", "changed"],
    a: 0,
    exp: "主語が I なので動詞は原形 change です。",
  },
  {
    q: "I am not _______ (just) one thing.",
    options: ["just", "only", "many", "some"],
    a: 0,
    exp: "not just one thing で「たった一つのものではない」となります。",
  },
  {
    q: "Tomorrow's _______ (wind) will blow.",
    options: ["rain", "wind", "sun", "snow"],
    a: 1,
    exp: "詩の文脈から「風 (wind)」が入ります。",
  },
  {
    q: "The wind will _______ (blow).",
    options: ["blow", "blew", "blown", "blowing"],
    a: 0,
    exp: "助動詞 will の後は動詞の原形 blow です。",
  },
  {
    q: "No _______ (matter) how I change.",
    options: ["problem", "matter", "way", "thing"],
    a: 1,
    exp: "No matter how で「どんなに～しても」という譲歩表現です。",
  },
  {
    q: "I am just me, _______ (as) I am.",
    options: ["so", "as", "like", "for"],
    a: 1,
    exp: "as I am で「あるがままの私」という意味です。",
  },
  {
    q: "I _______ (can) even be a dinosaur.",
    options: ["can", "do", "am", "have"],
    a: 0,
    exp: "「～になれる（可能性がある）」という can が適切です。",
  },
  {
    q: "I flow through this _______ (moment) now.",
    options: ["day", "time", "moment", "hour"],
    a: 2,
    exp: "「この瞬間」を表す moment が詩の中で使われています。",
  },
];

export default {
  id: "z7JRxkcy",
  title: "I am a Whale (ぼくはくじら)",
  level: "LEVEL 3",
  category: "poem",
  content: STORY_DATA,
  quizzes: QUIZ_POOL,
  puzzles: SCRAMBLE_POOL,
  fills: FILL_IN_THE_BLANK_POOL,
};

